import OurGoal from "./Ourgoal";
import OurTeam from "./ourteam";
// import Labour from "./labour";
const About = () => {
    return (
      <section id="about" style={{ padding: '50px 20px', backgroundColor: '#f0f0f0' }}>
        <div
          style={{
            maxWidth: '1000px',
            margin: '0 auto',
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            gap: '40px',
            marginBottom:"90px"
          }}
        >
          {/* Image */}
          <div data-aos="fade-right" style={{ flex: '1 1 300px' }}>
            <img
              src="/Gallerypics/Owner1.1.png"
              alt="Contractor"
              style={{
                width: '100%',
                borderRadius: '12px',
                boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
                objectFit: 'cover',
                height: '100%'
              }}
            />
          </div>
  
          {/* Text */}
          <div data-aos="fade-left" style={{ flex: '1 1 500px' }}>
            <h2 style={{ marginBottom: '20px' }}>About Us</h2>
            <p style={{ fontSize: '1rem', lineHeight: '1.6', marginBottom: '15px' }}>
              With over <strong>35 years</strong> of hands-on experience, our paint contracting team has delivered premium finishes for <strong>industrial sites</strong>, <strong>tennis courts</strong>,
              <strong>flour mills</strong>, <strong>game zones</strong>, and <strong>residential projects</strong> across the region.
            </p>
            <p style={{ fontSize: '1rem', lineHeight: '1.6', marginBottom: '15px' }}>
              We pride ourselves on <strong>quality workmanship</strong>, <strong>timely delivery</strong>, and <strong>customer satisfaction</strong>.
              No matter how big or small the job, we approach each project with full professionalism.
            </p>
            <p style={{ fontSize: '1rem', lineHeight: '1.6' }}>
              Let us bring color and protection to your space — the right way.
            </p>
          </div>
        </div>
        <OurTeam/>
        {/* <Labour/> */}
        <OurGoal/>
      </section>
    );
  };
  
  export default About;
  
